import React, { useState } from 'react';
import { Box, IconButton, TextField, Tooltip } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import { CustomTableCell } from 'src/components/MainPage/_shared/Table';
import { Stack } from '@mui/system';
import { activeStyles, disabledStyles } from './editableCellAppearance';

type Props = {
  value: string;
  onSave: (value: string) => void;
  onStartEditing: () => void;
  onStopEditing: () => void;
  isEditing: boolean;
  disabled?: boolean;
  placeholder?: string;
};

export const EditableTextCell = ({
  value,
  onSave,
  onStartEditing,
  onStopEditing,
  isEditing,
  disabled,
  placeholder,
}: Props) => {
  const [draft, setDraft] = useState(value);

  const handleSave = () => {
    onSave(draft.trim());
    onStopEditing();
  };

  const handleCancel = () => {
    setDraft(value);
    onStopEditing();
  };

  if (!isEditing) {
    return (
      <Tooltip title="Редактировать">
        <CustomTableCell
          className="text-cell"
          onClick={() => {
            if (!disabled) {
              setDraft(value);
              onStartEditing();
            }
          }}
          sx={disabled ? disabledStyles : activeStyles}
        >
          {value || '—'}
        </CustomTableCell>
      </Tooltip>
    );
  }

  return (
    <CustomTableCell sx={{ p: 0.25 }} className="text-cell">
      <Box display="flex" gap={0.25}>
        <TextField
          fullWidth
          autoFocus
          size="small"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleSave();
            if (e.key === 'Escape') handleCancel();
          }}
          placeholder={placeholder}
          sx={{ width: 'auto', flex: 1 }}
        />
        <Stack>
          <Tooltip title="Применить" placement="top">
            <IconButton
              disableRipple
              size="small"
              color="primary"
              onClick={handleSave}
              sx={{ p: 0 }}
            >
              <CheckBoxIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Отменить" placement="bottom">
            <IconButton
              disableRipple
              size="small"
              onClick={handleCancel}
              sx={{ p: 0 }}
            >
              <DisabledByDefaultIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      </Box>
    </CustomTableCell>
  );
};
